import { FC } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import { View } from './components/View';

const TaxesPages: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Catálogos',
            path: `/catalogos/`,
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        Tipo de impuesto
      </PageTitle>
      <View />
    </>
  );
};

export { TaxesPages };
